<template>
    <div class="quote grid grid__base">
        <div class="grid--container quote--container">
            <base-image class="quote--image" loading="lazy" v-bind="image"/>
            <div class="grid--row">
                <figure class="quote--text grid--col">
                    <blockquote class="quote--main" v-if="quote">&laquo;{{ quote }}&raquo;</blockquote>
                    <figcaption class="quote--author" v-if="author">{{ author }}</figcaption>
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            quote: {
                type: String,
                default: '',
            },
            author: {
                type: String,
                default: '',
            },
            image: {
                type: Object,
                required: true,
            },
        },
    };
</script>
